import * as types from '../constants/ActionTypes';

// Login process actions
export function loginStart() {
  return { type: types.AUTH_LOGIN_START };
}

export function loginSuccess(user) {
  return { 
    type: types.AUTH_LOGIN_SUCCESS,
    payload: { user }
  };
}

export function loginFailure(error) {
  return { 
    type: types.AUTH_LOGIN_FAILURE,
    payload: { error }
  };
}

export function logout() {
  return { type: types.AUTH_LOGOUT };
}

export function checkPublicRoute(path) {
  // List of paths that should be public
  const publicPaths = ['/viajeMenor', '/trabajoMenor', '/documentos/public'];
  const isPublic = publicPaths.some(publicPath => path.startsWith(publicPath));
  
  return {
    type: types.AUTH_CHECK_PUBLIC_ROUTE,
    payload: { isPublic }
  };
}

export function login(keycloak) {
  return async (dispatch) => {
    dispatch(loginStart());
    
    try {
      // Initialize Keycloak
      await keycloak.init({ onLoad: 'login-required' });
      
      if (keycloak.authenticated) {
        const userProfile = await keycloak.loadUserProfile();
        dispatch(loginSuccess(userProfile));
      } else {
        dispatch(loginFailure('Authentication failed'));
      }
    } catch (error) {
      dispatch(loginFailure(error.message));
    }
  };
}